import { Component, ViewChild } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { MenuController } from "@ionic/angular"
import { BasePage } from "../base.page"

@Component({
  selector: 'error-generic-page',
  templateUrl: 'error-generic.page.html',
  styleUrls: ['error-generic.page.scss']
})
export class ErrorGenericPage extends BasePage {

  constructor(
    public router: Router) {
    super(router)
  }
}